import React from 'react';

// PRD-003 WU B-10 — verdict badge for an outcome_evidence row.

const STYLES = {
  verified: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  unverified: 'bg-gray-100 text-gray-700 border-gray-200',
  contradicted: 'bg-red-100 text-red-800 border-red-200',
  needs_review: 'bg-amber-100 text-amber-800 border-amber-200',
};

const LABELS = {
  verified: 'Verified',
  unverified: 'Unverified',
  contradicted: 'Contradicted',
  needs_review: 'Needs Review',
};

export default function AgentVerdictBadge({ verdict, className = '' }) {
  const style = STYLES[verdict] || STYLES.needs_review;
  const label = LABELS[verdict] || verdict;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded border ${style} ${className}`}
    >
      {label}
    </span>
  );
}
